'use client'

import React from 'react'
import { useRouter } from 'next/navigation'
import clsx from 'clsx'
import { ERROR_MESSAGES } from '@/constants/messages'
import SettingButton from '@/components/Shared/Button/SettingButton'
import styles from '../styles.module.scss'

const { HEADING, DESCRIPTIONS, LOGIN_BUTTON } = ERROR_MESSAGES.PAGE.UNAUTHORIZED

export default function Error401() {
  const router = useRouter()

  return (
    <div className={clsx(styles.errorContent, styles.error401)}>
      <div className={styles.errorSection}>
        <h1 className={clsx(styles.errorCode, styles.warn)}>401</h1>
        <div className={styles.messageSection}>
          <h2 className={styles.errorHeading}>{HEADING}</h2>
          <p className={styles.errorDescription}>
            {DESCRIPTIONS.map((text, i) => (
              <React.Fragment key={i}>
                {i > 0 && <br />}
                {text}
              </React.Fragment>
            ))}
          </p>
        </div>
      </div>
      <div className={styles.customSection}>
        <SettingButton
          type='button'
          onClick={() => router.push('/login')}
          variant='primary'
          round={false}
          used='error'
        >
          {LOGIN_BUTTON}
        </SettingButton>
      </div>
    </div>
  )
}
